export const loader = () => ({
    position: 'absolute',
    top: 0,
    left: 0,
    background: 'white',
    height: '100%',
    width: '100%',
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
});

export const text = () => ({
    marginTop: '0.5rem',
});
